<template>
  <div class="alertInPage hover" v-bind:style="{'display':display}">
    <div class="alert alert-primary" role="alert" v-if="type==='primary'">
      {{msgPreInner}} {{ $t(msg) }} {{msgPostInner}}
    </div>
    <div class="alert alert-secondary" role="alert" v-if="type==='secondary'">
      {{msgPreInner}} {{ $t(msg) }} {{msgPostInner}}
    </div>
    <div class="alert alert-success" role="alert" v-if="type==='success'">
      {{msgPreInner}} {{ $t(msg) }} {{msgPostInner}}
    </div>
    <div class="alert alert-danger" role="alert" v-if="type==='danger'">
      {{msgPreInner}} {{ $t(msg) }} {{msgPostInner}}
    </div>
    <div class="alert alert-warning" role="alert" v-if="type==='warning'">
      {{msgPreInner}} {{ $t(msg) }} {{msgPostInner}}
    </div>
    <div class="alert alert-info" role="alert" v-if="type==='info'">
      {{msgPreInner}} {{ $t(msg) }} {{msgPostInner}}
    </div>
    <div class="alert alert-light" role="alert" v-if="type==='light'">
      {{msgPreInner}} {{ $t(msg) }} {{msgPostInner}}
    </div>
    <div class="alert alert-dark" role="alert" v-if="type==='dark'">
      {{msgPreInner}} {{ $t(msg) }} {{msgPostInner}}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AlertInPage',
    data(){
      return {
        display: "none",
        msgPreInner: "",
        msgPostInner: ""
//        , delayData: 4000
      }
    },
    mounted() {
//      if (typeof delay !== "undefined") {
//        this.delayData = delay;
//      }
    },
    props: {
      type: String, // primary secondary success danger warning info light dark
      msg: String,
      msgPre: {
        type: String,
        default: "",
      },
      msgPost: {
        type: String,
        default: "",
      },
//      delay: Number,
    },
    watch: {
      msg: function (newmsg, oldmsg) {
//        console.log("AlertInPage - run")
        const modul = this;
        if (newmsg.length > 0) {
          modul.display = "block"
        } else {
          modul.display = "none"
        }
        if (newmsg.length === 0) {
          modul.msgPreInner = "";
          modul.msgPostInner = "";
        }
      },
      msgPre: function (newmsg, oldmsg) {
        const modul = this;
//                if (msgPreInner.length === 0) {
        modul.msgPreInner = newmsg;
//                }
      },
      msgPost: function (newmsg, oldmsg) {
        const modul = this;
//                if (msgPostInner.length === 0) {
        modul.msgPostInner = newmsg;
//                }
      },

    },
    methods: {
      something(e){
        return e;
      },
    }

  };
</script>

<style>
  .alertInPage.hover {
    position: fixed;
    top: 25px;
    right: 100px;
    z-index: 10;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.7);
    border-radius: .25rem;
  }

  .alertInPage > div {
    margin-bottom: 0;
  }

</style>


